import { cn } from '@/lib/utils';

interface LogoProps {
  size?: number;
  withWord?: boolean;
  className?: string;
}

export function Logo({ size = 22, withWord = true, className }: LogoProps) {
  return (
    <span className={cn('inline-flex items-center gap-2 text-ink', className)}>
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
        <circle cx="6" cy="6" r="2.2" fill="currentColor" />
        <circle cx="18" cy="6" r="2.2" fill="currentColor" opacity="0.55" />
        <circle cx="6" cy="18" r="2.2" fill="currentColor" opacity="0.55" />
        <circle cx="18" cy="18" r="2.2" fill="currentColor" />
        <path d="M6 6 L18 18 M18 6 L6 18" stroke="currentColor" strokeWidth="1.4" opacity="0.85" />
      </svg>
      {withWord && (
        <span
          className="font-semibold tracking-[-0.02em]"
          style={{ fontSize: size * 0.78 }}
        >
          Synapse
        </span>
      )}
    </span>
  );
}
